var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    stroke: "#2C67F1",
    strokeWidth: 1.5,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91536 2.10742V5.03322C9.91536 5.42992 9.91537 5.62828 9.99257 5.7798C10.0605 5.91308 10.1688 6.02144 10.3021 6.08935C10.4536 6.16655 10.652 6.16655 11.0487 6.16655H13.9745M8.4987 13.2498V8.99984M6.3737 11.1248H10.6237M9.91536 1.9165H6.23203C5.04192 1.9165 4.44686 1.9165 3.9923 2.14812C3.59246 2.35185 3.26737 2.67693 3.06364 3.07677C2.83203 3.53134 2.83203 4.12639 2.83203 5.3165V12.6832C2.83203 13.8733 2.83203 14.4683 3.06364 14.9229C3.26737 15.3227 3.59246 15.6478 3.9923 15.8516C4.44686 16.0832 5.04192 16.0832 6.23203 16.0832H10.7654C11.9555 16.0832 12.5505 16.0832 13.0051 15.8516C13.4049 15.6478 13.73 15.3227 13.9338 14.9229C14.1654 14.4683 14.1654 13.8733 14.1654 12.6832V6.1665L9.91536 1.9165Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlus);
export default __webpack_public_path__ + "static/media/file-plus.bdef2771a319ce3a4c7f9ed327c24728.svg";
export { ForwardRef as ReactComponent };